import { useAuth } from "@/services/auth";

const baseUrl = `${window.__RUNTIME_CONFIG__.BASE_URL}/api/v1/file/by-runtime-token`;

export const useRuntimeImage = () => {
  const { runtimeToken } = useAuth();
  const getRuntimeImageURL = ({ fileId }: { fileId: string }) => {
    const url = new URL(baseUrl);
    if (!runtimeToken || !fileId) return "";
    url.searchParams.append("id", fileId);
    url.searchParams.append("runtimeToken", decodeURIComponent(runtimeToken));
    return url.href;
  };

  return { getRuntimeImageURL };
};
